// extracted by mini-css-extract-plugin
export default {"sidebyside":"AddBreak_sidebyside__yELEE","name":"AddBreak_name__aVoZd"};